import React, { useEffect, useState } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getWarehousesByCity } from "../api/novaposhta";

const NovaPoshtaWarehouseSelect = ({ cityName, value, onChange }) => {
  const { t } = useTranslation("common");
  const [warehouses, setWarehouses] = useState([]);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const fetchWarehouses = async (pageToFetch = 1, search = "") => {
    if (!cityName) return;
    setLoading(true);
    try {
      const res = await getWarehousesByCity(cityName, search, pageToFetch);
      if (pageToFetch === 1) {
        setWarehouses(res);
      } else {
        setWarehouses((prev) => [...prev, ...res]);
      }
      setHasMore(res.length >= 30); // Наприклад, якщо по 30 штук
    } catch (e) {
      console.error("Помилка завантаження відділень", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    fetchWarehouses(1, inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityName]);

  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;
    const bottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 1;
    if (bottom && hasMore && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchWarehouses(nextPage, inputValue);
    }
  };

  return (
    <Autocomplete
      options={warehouses}
      getOptionLabel={(option) => option.Description}
      value={warehouses.find((w) => w.Description === value) || null}
      onChange={(_, newVal) => onChange(newVal ? newVal.Description : "")}
      onInputChange={(_, val) => {
        setInputValue(val);
        setPage(1);
        fetchWarehouses(1, val);
      }}
      loading={loading}
      ListboxProps={{ onScroll: handleScroll }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("form.branch")}
          placeholder={t("form.selectBranch")}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default NovaPoshtaWarehouseSelect;
